import SubmissionError from '../error/SubmissionError'
import AuthorizationError from '../error/AuthorizationError'
import security from './security'
import { API_HOST, API_PATH } from '../config/_entrypoint'

const jsonLdMimeType = 'application/ld+json'

function assign (obj, keyPath, value) {
  const lastKeyIndex = keyPath.length - 1
  for (var i = 0; i < lastKeyIndex; ++i) {
    let key = keyPath[i]
    if (!(key in obj))
      obj[key] = {}
    obj = obj[key]
  }
  obj[keyPath[lastKeyIndex]] = value
}

const buildQueryParams = function (page = 1, order = {}, filter = {} ) {
  let queryParameters = [];
  if(page != undefined){
    queryParameters.push('page=' + page);
  }

  if (order.field != undefined && order.field != '') {
    queryParameters.push('order[' + order.field + ']=' + order.direction);
  }
  if (filter != undefined) {
    for (let property in filter) {
      if( filter[property] !== undefined &&  filter[property] !== null &&  filter[property]!==''){
        if(filter[property].before || filter[property].after) {
          if (filter[property].before) {
            queryParameters.push(property + '[before]=' + encodeURI(filter[property].before));
          }
          if (filter[property].after) {
            queryParameters.push(property + '[after]=' + encodeURI(filter[property].after));
          }
        }else {
          queryParameters.push(property + '=' + encodeURI(filter[property]));
        }
      }
    }
  }
  return queryParameters.join('&');
}
const buildError = function (json) {
  const error = json['hydra:description'] ? json['hydra:description'] : json
  if (!json.violations){
    return new Error(error)
  }

  const errors = {_error: error}
  json.violations.map((violation) => {
    const errorPath = violation.propertyPath.split('.')
    assign(errors, errorPath, violation.message)
  })

  return  new SubmissionError(errors)
}

const makeRequest = function (url, options = {}) {
  if ('undefined' === typeof options.headers) options.headers = new Headers()
  if (null === options.headers.get('Accept')) options.headers.set('Accept', jsonLdMimeType)

  if ('undefined' !== options.body && !(options.body instanceof FormData) && null === options.headers.get('Content-Type')) {
    options.headers.set('Content-Type', jsonLdMimeType)
  }

  if (null === options.headers.get('authorization') && null !== security.getToken()) {
    options.headers.set('authorization', 'Bearer ' + security.getToken())
  }
  const link = url.includes(API_PATH) ? API_HOST + url : API_HOST + API_PATH + url

  return fetch(link, options).then(response => {
    if (response.ok) return response
    else if (response.ok === false && response.status === 401) {
      return response.json().then(json => {
        throw new AuthorizationError(json.message)
      })
    }
    return response
      .json()
      .then(json => {
        throw buildError(json)
      })
  })
}

const download = function (url) {
  const options = {method: 'POST', body: '{}'};

  if ('undefined' === typeof options.headers) options.headers = new Headers()
  if (null === options.headers.get('Accept')) options.headers.set('Accept', jsonLdMimeType)

  if ('undefined' !== options.body && !(options.body instanceof FormData) && null === options.headers.get('Content-Type')) {
    options.headers.set('Content-Type', jsonLdMimeType)
  }

  if (null === options.headers.get('authorization') && null !== security.getToken()) {
    options.headers.set('authorization', 'Bearer ' + security.getToken())
  }
  const link = url.includes(API_PATH) ? API_HOST + '/file_tokens' : API_HOST + API_PATH + '/file_tokens'

  fetch(link, options).then(response => {
    if (response.ok) {
      response.json().then( json => {
        window.location.href = url.includes(API_PATH) ? API_HOST + url + 'token=' + json.id : API_HOST + API_PATH + url + 'token=' + json.id

      });
    }
    else if (response.ok === false && response.status === 401) {
      return response.json().then(json => {
        throw new AuthorizationError(json.message)
      })
    }
    return response
      .json()
      .then(json => {
        throw buildError(json)
      })
  })
}

const preview = function (url) {
  const options = {method: 'POST', body: '{}'};

  if ('undefined' === typeof options.headers) options.headers = new Headers()
  if (null === options.headers.get('Accept')) options.headers.set('Accept', jsonLdMimeType)

  if ('undefined' !== options.body && !(options.body instanceof FormData) && null === options.headers.get('Content-Type')) {
    options.headers.set('Content-Type', jsonLdMimeType)
  }

  if (null === options.headers.get('authorization') && null !== security.getToken()) {
    options.headers.set('authorization', 'Bearer ' + security.getToken())
  }
  const link = url.includes(API_PATH) ? API_HOST + '/file_tokens' : API_HOST + API_PATH + '/file_tokens'

  fetch(link, options).then(response => {
    if (response.ok) {
      response.json().then( json => {
        window.open(url.includes(API_PATH) ? API_HOST + url + 'token=' + json.id : API_HOST + API_PATH + url + 'token=' + json.id, '_blank').focus();

      });
    }
    else if (response.ok === false && response.status === 401) {
      return response.json().then(json => {
        throw new AuthorizationError(json.message)
      })
    }
    return response
      .json()
      .then(json => {
        throw buildError(json)
      })
  })
}

const extractId = function(url) {
  return url.substr(url.lastIndexOf('/') + 1);
}

export default {
  fetch: makeRequest,
  download: download,
  preview: preview,
  buildQueryParams,
  buildError,
  extractId
}


// WEBPACK FOOTER //
// ./src/utils/http.js